<template>
  <Adminlte>
    <p v-if="this.park.currentStage === 'Operação'">
      <button class="btn btn-sm btn-success" @click="createCompany"><i class="fa fa-plus"></i>&nbsp Novo</button>
    </p>
    <div class="box">
      <div class="box-header">
        <h3 class="box-title">Empresas do {{this.park.initials}}</h3>
      </div>
      <div class="box-body">
        <DataTables
          tableId="parks-table"
          :url="this.getApiUrl()"
          :columns="this.columns"
          :columnDefs="this.columnDefs">
        </DataTables>
      </div>
    </div>
    <go-back-button></go-back-button>
    <notifier ref="notifier"></notifier>
    <!-- Modal -->
    <div class="modal fade" id="delete-company-modal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">Excluir Empresa</h4>
          </div>
          <div class="modal-body">
            <p>Ao clicar em "Ok" a empresa será excluída do sistema. Esta ação é irreversível! Deseja continuar?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Cancelar</button>
            <button id="delete-company-modal-confirm" type="button" class="btn btn-primary" data-dismiss="modal">Ok</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="unlink-company-modal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">Desligar Empresa</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <p>Informe a data do desligamento para prosseguir:</p>
              <DatePicker
                placeholder="Selecione a data"
                :bootstrapStyling="true"
                :language="datepickerLanguage"
                v-model="unlinkCompanyDate">
              </DatePicker>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Cancelar</button>
            <button
              id="unlink-company-modal-confirm"
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              :disabled="!unlinkCompanyDate"
            >
              Desligar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="relink-company-modal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">Religar Empresa</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <p>Informe a data do religamento para prosseguir:</p>
              <DatePicker
                placeholder="Selecione a data"
                :bootstrapStyling="true"
                :language="datepickerLanguage"
                v-model="relinkCompanyDate">
              </DatePicker>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Cancelar</button>
            <button
              id="relink-company-modal-confirm"
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              :disabled="!relinkCompanyDate"
            >
              Religar
            </button>
          </div>
        </div>
      </div>
    </div>
  </Adminlte>
</template>
<script>
import Adminlte from '@/components/template/Adminlte'
import DataTables from '@/components/elements/DataTables'
import ParkClient from '@/services/resource_client/park'
import GoBackButton from '@/components/elements/GoBackButton'
import { BackendApi } from '@/services/backend_api'
import CompanyClient from '@/services/resource_client/company'
import DateFormatter from '@/services/date_formatter'
import Notifier from '@/components/elements/Notifier'
import Authentication from '@/services/authentication'
import DatePicker from 'vuejs-datepicker'
import { ptBR } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'CompaniesHome',
  components: { Adminlte, DataTables, GoBackButton, Notifier, DatePicker },
  data () {
    return {
      datepickerLanguage: ptBR,
      park: {},
      columns: [
        { label: 'Nome', field: 'name' },
        { label: 'Email', field: 'email' },
        { label: 'Desligada', field: 'isLinkedToPark' },
        { label: 'Opções', field: null }
      ],
      columnDefs: [
        {
          targets: 2,
          render: function (isLinkedToPark, type, full, meta) {
            return isLinkedToPark ? 'Não' : 'Sim'
          }
        },
        {
          targets: -1,
          orderable: false,
          render: (data, type, full, meta) => {
            const unlinkOrRelinkButtonBasedUponCurrentState = data.isLinkedToPark
              ? `<button
                class="btn btn-xs btn-warning unlink-company"
                data-company-id=` + data.id + `
                data-toggle="modal"
                data-target="#unlink-company-modal"
                >
                  <i class="fa fa-trash"></i>&nbsp Desligar
              </button>`
              : `<button
                class="btn btn-xs btn-warning relink-company"
                data-company-id=` + data.id + `
                data-toggle="modal"
                data-target="#relink-company-modal"
                >
                  <i class="fa fa-trash"></i>&nbsp Religar
              </button>`

            let buttons = `
              <button
                class="btn btn-xs btn-primary edit-company"
                data-company-id=` + data.id + `>
                  <i class="fa fa-pencil"></i>&nbsp Editar
              </button>
              ${unlinkOrRelinkButtonBasedUponCurrentState}
            `

            if (this.canDeleteCompany) {
              buttons = `${buttons}
              <button
                class="btn btn-xs btn-danger delete-company"
                data-company-id=` + data.id + `
                data-toggle="modal"
                data-target="#delete-company-modal"
                >
                  <i class="fa fa-trash"></i>&nbsp Excluir
              </button>`
            }

            return buttons
          }
        }
      ],
      deleteCompanyId: '',
      unlinkCompanyId: null,
      unlinkCompanyDate: null,
      relinkCompanyId: null,
      relinkCompanyDate: null
    }
  },
  props: ['parkId'],
  created () {
    ParkClient.get(this.parkId)
      .then(r => { this.park = r.data })
  },
  mounted () {
    this.bindEditCompanyButtonClick()
    this.bindDeleteCompanyButtonClick()
    this.bindConfirmDeleteCompany()
    this.bindUnlinkCompanyButtonClick()
    this.bindConfirmUnlinkCompany()
    this.bindRelinkCompanyButtonClick()
    this.bindConfirmRelinkCompany()
  },
  methods: {
    getApiUrl () {
      return process.env.API_URL + 'parks/' + this.parkId + '/companies/'
    },
    createCompany () {
      this.$router.push({ name: 'CreateCompany', params: { parkId: this.parkId } })
    },
    bindEditCompanyButtonClick () {
      let that = this
      $(document).on('click', '.edit-company', function (e) {
        let companyId = $(this).data('company-id')
        that.editCompany(companyId)
      })
    },
    editCompany (id) {
      this.$router.push({ name: 'EditCompany', params: { id: id } })
    },
    bindDeleteCompanyButtonClick () {
      let that = this
      $('body').off('click', '.delete-company')
        .on('click', '.delete-company', function (e) {
          that.deleteCompanyId = $(this).data('company-id')
          console.log($(this).data('company-id'))
        })
    },
    bindConfirmDeleteCompany () {
      let that = this
      $('body').off('click', '#delete-company-modal-confirm')
        .on('click', '#delete-company-modal-confirm', function (e) {
          that.deleteCompany()
        })
    },
    deleteCompany () {
      BackendApi.getClient().delete(`companies/${this.deleteCompanyId}`)
        .then(response => {
          this.reloadTable()
          this.showCompanyDeleteSuccessNotification()
        })
        .catch(e => {
          this.showCompanyDeleteErrorNotification()
        })
    },
    bindUnlinkCompanyButtonClick () {
      let that = this
      $('body').off('click', '.unlink-company')
      .on('click', '.unlink-company', function (e) {
        that.unlinkCompanyId = $(this).data('company-id')
        that.unlinkCompanyDate = null
      })
    },
    bindConfirmUnlinkCompany () {
      let that = this
      $('body').off('click', '#unlink-company-modal-confirm')
      .on('click', '#unlink-company-modal-confirm', function (e) {
        that.unlinkCompany()
      })
    },
    unlinkCompany () {
      const dateAsApiFormat = DateFormatter.formatAPIDate(this.unlinkCompanyDate)
      CompanyClient.unlink(this.unlinkCompanyId, dateAsApiFormat)
        .then(response => {
          this.reloadTable()
          this.showCompanyUnlinkSuccessNotification()
        })
        .catch(e => {
          this.showCompanyUnlinkErrorNotification()
        })
    },
    bindRelinkCompanyButtonClick () {
      let that = this
      $('body').off('click', '.relink-company')
      .on('click', '.relink-company', function (e) {
        that.relinkCompanyId = $(this).data('company-id')
        that.relinkCompanyDate = null
      })
    },
    bindConfirmRelinkCompany () {
      let that = this
      $('body').off('click', '#relink-company-modal-confirm')
      .on('click', '#relink-company-modal-confirm', function (e) {
        that.relinkCompany()
      })
    },
    relinkCompany () {
      const dateAsApiFormat = DateFormatter.formatAPIDate(this.relinkCompanyDate)
      CompanyClient.relink(this.relinkCompanyId, dateAsApiFormat)
        .then(response => {
          this.reloadTable()
          this.showCompanyRelinkSuccessNotification()
        })
        .catch(e => {
          this.showCompanyRelinkErrorNotification()
        })
    },
    reloadTable () {
      $('#parks-table').DataTable().ajax.reload()
    },
    showCompanyDeleteSuccessNotification () {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'A empresa foi excluída do sistema!' })
    },
    showCompanyDeleteErrorNotification () {
      this.$notify({ type: 'error', title: 'Erro', text: 'Ocorreu um erro ao excluir a empresa! Entre em contato com a equipe de desenvolvimento.' })
    },
    showCompanyUnlinkSuccessNotification () {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'A empresa foi desligada do parque!' })
    },
    showCompanyUnlinkErrorNotification () {
      this.$notify({ type: 'error', title: 'Erro', text: 'Ocorreu um erro ao desligar a empresa! Entre em contato com a equipe de desenvolvimento.' })
    },
    showCompanyRelinkSuccessNotification () {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'A empresa foi religada ao parque!' })
    },
    showCompanyRelinkErrorNotification () {
      this.$notify({ type: 'error', title: 'Erro', text: 'Ocorreu um erro ao religar a empresa! Entre em contato com a equipe de desenvolvimento.' })
    }
  },
  computed: {
    canDeleteCompany () {
      return Authentication.userHasAdminRole() || Authentication.userHasResearcherRole()
    }
  }
}
</script>



// WEBPACK FOOTER //
// CompaniesHome.vue?0272c63d